import React from "react";
import { ChantCheckbox, ChantInput } from "../../../../CommonComponents";

const LeaderDetails = ({ control, isSaving }) => {
  return (
    <div
      style={{
        border: "2px solid #e8e8e8",
        padding: "20px",
        margin: "24px 0px",
        borderRadius: "8px",
      }}
    >
      <h3
        style={{
          fontWeight: 600,
          color: "var(--text-color)",
          fontSize: "15px",
          margin: "0 0 20px 0",
          letterSpacing: "0.1px",
        }}
      >
        Leader Details
      </h3>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          marginTop: "12px",
        }}
      >
        <ChantInput
          label={
            <span
              style={{
                fontWeight: 600,
                color: "var(--text-color)",
                fontSize: "13px",
              }}
            >
              Title
            </span>
          }
          control={control}
          name="title"
          placeholder="e.g., President, Vice President"
          disabled={isSaving}
          tabIndex="2"
        />

        <ChantInput
          label={
            <div
              style={{ display: "flex", flexDirection: "column", gap: "3px" }}
            >
              <span
                style={{
                  fontWeight: 600,
                  color: "var(--text-color)",
                  fontSize: "13px",
                }}
              >
                Email
              </span>
              <span
                style={{
                  fontSize: "11px",
                  color: "var(--text-color)",
                  lineHeight: "1.4",
                  wordBreak: "break-word",
                }}
              >
                Populate only if you have an official group email (president@).
              </span>
            </div>
          }
          control={control}
          name="leaderEmail"
          placeholder="president@example.com"
          disabled={isSaving}
          tabIndex="2"
        />

        <div
          style={{
            paddingTop: "4px",
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <ChantCheckbox
            label={
              <span
                style={{
                  color: "var(--text-color)",
                  fontSize: "13px",
                  lineHeight: "1.5",
                  wordBreak: "break-word",
                }}
              >
                Show profile in Leaders section of Members List. Admins are
                shown by default.
              </span>
            }
            type="secondary"
            control={control}
            name="showLeadersProfile"
            disabled={isSaving}
          />
        </div>
      </div>
    </div>
  );
};

export default LeaderDetails;
